module.exports = __webpack_public_path__ + "static/media/male.3caa4d83.png";